import { IScoreDogClass } from "./score-dog-class.interface";

export class IScoreDogClassExt extends IScoreDogClass {
  //
  show_id: string;
}
